export const CATEGORY_ALL_COVER_IMAGE_URL =
  'https://resilient.sfo2.cdn.digitaloceanspaces.com/cookbook/covers/categoryAll.jpg';
export const CATEGORY_ALL_NAME = 'cookbook.mealCategoryThumb.allMealsTitle';
